export const bugsnag = {
    name: 'Bugsnag',
    key: 'bugsnag',
    assets: {
        icon: '/images/competitors/bugsnag.svg',
    },
    products: {
        error_tracking: {
            available: true,
            features: {
                console_log_capture: false,
                error_alerts: true,
                exception_capture: true,
                issue_management: true,
                error_grouping: true,
                stack_tracing: true,
                mobile_sdk_coverage: true,
                source_map_support: true,
                user_device_context: true,
            },
            monitoring: {
                features: {
                    cron_monitoring: '',
                    release_tracking: true,
                    performance_monitoring: true,
                },
            },
            integrations: {
                ab_experiments: true,
                datadog: false,
                product_analytics: false,
                session_replay: false,
            },
        },
    },
    platform: {
        deployment: {
            eu_hosting: false,
            managed_reverse_proxy: false,
            open_source: false,
            self_host: false,
            ci_cd_integrations: true,
        },
        pricing: {
            free_tier: true,
            transparent_pricing: false,
            usage_based_pricing: false,
        },
        developer: {
            api: false,
            collaboration: false,
            mobile_sdks: false,
            native_data_sources: false,
            proxies: false,
            sdks: false,
            server_side_sdks: false,
            sql: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            azure_blob: false,
            bigquery: false,
            cdp: false,
            ci_cd_integrations: true,
            community_integrations: false,
            csv_exports: false,
            customer_io: false,
            data_warehouse: false,
            email_reports: false,
            exports: false,
            gcs: false,
            google_ads: false,
            hubspot: false,
            imports: false,
            intercom: false,
            microsoft_teams: false,
            redshift: false,
            rudderstack: false,
            s3: false,
            salesforce: false,
            segment: false,
            sentry: false,
            slack: false,
            snowflake: false,
            stripe: false,
            warehouse_import: false,
            wordpress: false,
            zapier: false,
            zendesk: false,
        },
        security: {
            bot_blocking: false,
            cookieless_tracking: false,
            data_anonymization: false,
            data_retention: false,
            gdpr_ready: false,
            hipaa_ready: false,
            history_audit_logs: false,
            reverse_proxy: false,
            saml_sso: false,
            soc2_certified: false,
            two_factor_auth: false,
            user_privacy_options: false,
        },
        analytics_integration: {
            built_in_analytics: false,
        },
    },
    pricing: {
        model: 'Seat-based',
    },
}
